export default __webpack_public_path__ + "static/media/gaming.d50a7661.png";